<template>
  <div>
    <!-- <el-button
      type="primary"
      icon="el-icon-plus"
      @click="setUserinfoDetailDialogVisible = true"
      >添加</el-button
    > -->
    <el-dialog
      :visible="userinfoDetailDialogVisible"
      title="修改高度任务信息"
      width="820px"
      @close="closeDialog"
    >
      <el-form :model="changeForm" ref="form"   label-width="160px">
        <el-form-item label="创建时间：">
          {{ changeForm.createTime }}
        </el-form-item>
        <el-form-item label="币种：">
          <el-input v-model="changeForm.coinType" disabled></el-input>
        </el-form-item>
        <el-form-item label="id：">
          <el-input v-model="changeForm.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="重试次数：">
          <el-input v-model="changeForm.retryTimes"></el-input>
        </el-form-item>
        <el-form-item label="高度">
          <el-input v-model="changeForm.height"></el-input>
        </el-form-item>
      
        <!-- <el-form-item label="完成状态：">
          <el-switch v-model="changeForm.isFinished"></el-switch>
        </el-form-item> -->
        <el-form-item label="执行状态：">
          <el-select v-model="changeForm.executionStatus" >
              <el-option
                v-for="item in executionStatusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
        </el-form-item>
    
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'updatedialog',
props:['page','size','height','coinType','executionStatus'],
  data() {
    return {
      changeForm: {
     
      },
      executionStatusOption:[
        { value: 0, label: '待执行' },
        { value: 1, label: '执行中' },
        { value: 2, label: '已执行' },
        { value: 3, label: '执行失败' },
        
      ],
      rules:{
        telCountryCode:[{required:true,message:'区号必选',trigger:blur}]
      }
      
      
    };
  },
  watch: {
    userinfoDetail(val, oldVal) {
      if (val !== oldVal) {
        this.changeForm = { ...val };
      }
    }
  },
  computed: {
    ...mapState('blockHeightTask', [
      'userinfoDetail',
      'userinfoDetailDialogVisible',
      'countryCodeList',
      'pagination','queryType'
    ]),
    ...mapGetters('blockHeightTask', ['userList'])
  },
  methods: {
    ...mapMutations('blockHeightTask', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    ...mapActions('blockHeightTask', ['updatInfo','list','resetPassword','getBlockHeightTask']),
    closeDialog() {
      this.setUserinfoDetailDialogVisible(false);
    },
    handleSave() {
      let updateInfo = {
        ...this.changeForm,
        id:Number(this.changeForm.id) ,
        executionStatus:Number(this.changeForm.executionStatus),
        height: Number(this.changeForm.height),
        retryTimes: Number(this.changeForm.retryTimes),
      
      };
      console.log(updateInfo);
      console.log('page',this.page,'size',this.size);
      this.updatInfo(updateInfo).then(res=>{
        if(res.code==0){
          this.setUserinfoDetailDialogVisible(false);
           this.$message.success('修改成功')
           this.getBlockHeightTask({
            coinType:this.coinType,
            height:this.height,
            executionStatus:this.executionStatus,
            page:this.page,
            size:this.size,
      });
        
        }
      });
    },
    resetLoginPassword(id){
      this.resetPassword({userId:id}).then(()=>{
        this.$message.success('重置成功！');
      })
    }
  },
  created() {
    // this.coutryCode();
  }
};
</script>

<style lang="less" scoped>
::v-deep.el-select {
  .el-input__inner {
    width: 100px;
  }
}
</style>
